import _regeneratorRuntime from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var _this = this;

import * as tslib_1 from "tslib";
import _ from 'lodash';
import { PlaceOrderUrl, GetOrdersUrl, SearchOrdersUrl, CancelOrderUrl, ChangeOrderUrl } from '../constants';
import { transformForApi, transformFromApi, transformOrderForApi } from '..';
import dayjs from 'dayjs';
var httpOptions = {
  headers: {
    Accept: 'application/json'
  }
};

var _create = function create(api) {
  return function (orderDesc) {
    var order = transformForApi(orderDesc);
    return api.authenticated().post(PlaceOrderUrl, order, httpOptions);
  };
};

export { _create as create };

var _change = function change(api) {
  return function (orderDesc) {
    var order = transformOrderForApi(orderDesc);
    return api.authenticated().post(ChangeOrderUrl, order, httpOptions);
  };
};

export { _change as change };

var _cancel = function cancel(api) {
  return function (orderId, accountId) {
    // might need to pass subaccountId, clientRefId params at some point: https://devapi.tradingblock.com/swagger-ui#/Orders/CancelOrder
    var data = {
      orderId: orderId,
      accountId: accountId
    };
    return api.authenticated().post(CancelOrderUrl, data, httpOptions);
  };
};

export { _cancel as cancel };

var buildOrderQueryPayload = function buildOrderQueryPayload(options) {
  var request = _.omit(options, ['blockId']);

  return _.pickBy(Object.assign({}, request, {
    dateFrom: request.dateFrom ? dayjs(request.dateFrom).utc().toDate() : undefined,
    dateTo: request.dateTo ? dayjs(request.dateTo).utc().toDate() : undefined
  }), function (v) {
    return v !== undefined;
  });
};

var normalizeOrdersApiResponse = function normalizeOrdersApiResponse(apiResponse) {
  return Object.assign({}, apiResponse, {
    payload: apiResponse.payload ? function () {
      var p = apiResponse.payload; // Legacy API used PascalCase Items; some responses used lowercase items only for this endpoint.

      var rawList = p.Items != null ? p.Items : p.items;
      return Object.assign({}, apiResponse.payload, {
        items: _.map(rawList, transformFromApi)
      });
    }() : undefined
  });
};

export var getOrders = function getOrders(api) {
  return function (options) {
    return tslib_1.__awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var optionValues, apiResponse;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              optionValues = buildOrderQueryPayload(options);
              _context.next = 3;
              return api.authenticated().get(GetOrdersUrl, optionValues, httpOptions);

            case 3:
              apiResponse = _context.sent;
              return _context.abrupt("return", normalizeOrdersApiResponse(apiResponse));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };
};
export var searchOrders = function searchOrders(api) {
  return function (accountId, request) {
    return tslib_1.__awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      var body, apiResponse;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              body = buildOrderQueryPayload(request);
              _context2.next = 3;
              return api.authenticated().post(SearchOrdersUrl(accountId), body, httpOptions);

            case 3:
              apiResponse = _context2.sent;
              return _context2.abrupt("return", normalizeOrdersApiResponse(apiResponse));

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
  };
};
export function order(api) {
  var _this2 = this;

  return function (accountId, subaccountId) {
    return {
      change: function change(req) {
        return tslib_1.__awaiter(_this2, void 0, void 0,
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee3() {
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return _change(api)(req);

                case 2:
                  return _context3.abrupt("return", _context3.sent);

                case 3:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));
      },
      create: function create(orderDesc) {
        return tslib_1.__awaiter(_this2, void 0, void 0,
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee4() {
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  return _context4.abrupt("return", _create(api)(Object.assign({}, orderDesc, {
                    AccountId: accountId,
                    kind: 'order'
                  })));

                case 1:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));
      },
      get: function get(request) {
        return tslib_1.__awaiter(_this2, void 0, void 0,
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee5() {
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  return _context5.abrupt("return", getOrders(api)(Object.assign({}, request, {
                    accountId: accountId,
                    subaccountId: subaccountId
                  })));

                case 1:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));
      },
      search: function search(request) {
        return tslib_1.__awaiter(_this2, void 0, void 0,
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee6() {
          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  return _context6.abrupt("return", searchOrders(api)(accountId, Object.assign({}, request, {
                    subaccountId: subaccountId
                  })));

                case 1:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6);
        }));
      },
      cancel: function cancel(orderId) {
        return tslib_1.__awaiter(_this2, void 0, void 0,
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee7() {
          return _regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  return _context7.abrupt("return", _cancel(api)(orderId, accountId));

                case 1:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7);
        }));
      }
    };
  };
}